module.exports = __webpack_public_path__ + "r-healthcare.png?2d57b0938726e0ab9e39c0cc75e2ec0f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/r-healthcare.png
// module id = 56
// module chunks = 0